import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { AddAMemberService } from './add-a-member.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { AccountService } from 'src/app/core/services/account.service';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-add-a-member-modal-window',
  templateUrl: './add-a-member-modal-window.component.html',
  styleUrls: ['./add-a-member-modal-window.component.scss']
})
export class AddAMemberModalWindowComponent implements OnInit {
  addMemberForm: UntypedFormGroup;
  submitted = false;
  adpData: any;
  requestorFirstName: string;
  requestorLastName: string;
  requestorFullName: string;
  requestorEmail: string;
  contractNumber;
  isErrorInAdd: boolean;
  selectedContract: ISelectedContract;
  emailSent = false;
  memberReactivated = false;
  emailsInAccount: string[];
  memberAvatarUrl : any;
  memberAvatarColor: any;
  isElitaActive : boolean = false;
  validationError: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    public dialogRef: MatDialogRef<AddAMemberModalWindowComponent>,
    private fb: UntypedFormBuilder,
    private addMemberService: AddAMemberService,
    private loggedInUserSettings: LoggedInUserSettings,
    private accountService: AccountService,
    private resourceService: ADPResourceService
  ) { }

  ngOnInit() {
    this.isElitaActive = this.resourceService.isPortalSettingTrue('Global_CTC_IsElita');
    this.addMemberForm = this.fb.group({
      Email: ['', [Validators.required, Validators.email]],
      FirstName: ['', [Validators.required]],
      LastName: ['', [Validators.required]]
    });

    this.loggedInUserSettings.$selectedContract.subscribe(selected => {
      if (!selected) {
        return;
      }
      this.contractNumber = selected.id;
      this.requestorFirstName = selected.firstName;
      this.requestorLastName = selected.lastName;
      this.requestorFullName = this.requestorFirstName + ' ' + this.requestorLastName;
      this.requestorEmail = selected.primaryUserEmail;
      this.emailsInAccount = selected.members?.map(x => x.emailAddress);
      this.selectedContract = selected;
      selected.members.filter(x => {
        if(x.emailAddress === this.requestorEmail){
          this.memberAvatarUrl = x.avatarUrl;
        }
      });
    });
  }

  get addMemberFormControl() {
    return this.addMemberForm.controls;
  }

  get validEmail(): boolean {
    return !this.emailsInAccount.filter(email => email?.toLowerCase() === this.addMemberForm.value.Email.toLowerCase()).length;
  }

  onSubmit() {
    this.submitted = true;
    this.loggedInUserSettings.clearContractFromCache();

    if (this.addMemberForm?.valid && this.validEmail) {
      const existingMember = this.selectedContract.inactiveMembers.find(m => m.emailAddress === this.addMemberForm.value.email);
      this.adpData = { 'fullName': this.addMemberForm.value.FirstName + ' ' + this.addMemberForm.value.LastName };

      if (!existingMember) {
        const postData = {
          TenantId: this.resourceService.getPortalSetting('Global_TenantId').Value,
          ContractId: this.contractNumber,
          FirstName: this.addMemberForm.value.FirstName,
          LastName: this.addMemberForm.value.LastName,
          EmailAddress: this.addMemberForm.value.Email,
          RequestorFirstName: this.requestorFirstName,
          RequestorLastName: this.requestorLastName
        };

        this.addMemberService.postInviteSubmit(postData)
          .subscribe({
            next: () => {
              this.emailSent = true;
            },
            error: (err) => {
              if (err.error && err.error.ErrorCode == 'OktaUserAlreadyExist') {
                this.validationError = this.resourceService.getViewLabel('Global_Error_Code_OktaUserAlreadyExist');
              } else if (err.error && err.error.ErrorCode == 'InviteeIdAlreadyExists') {
                this.validationError = this.resourceService.getViewLabel('Global_Error_Code_InviteeIdAlreadyExists');
              }
            }
          });
      } else {
        if(!this.isElitaActive){
          this.accountService.reactivateFamilyMember(existingMember.emailAddress, this.contractNumber).subscribe(() => {
            const allMembers = [...this.selectedContract.members, ...this.selectedContract.inactiveMembers];
            allMembers.find(m => m.emailAddress === this.addMemberForm.value.Email).profileStatus = 'A';
            this.selectedContract.members = allMembers;
            this.loggedInUserSettings.setSelectedContract(this.selectedContract);
            this.memberReactivated = true;
          });
        }
      }
    }
  }

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : "Account_Manage_Members_AddMember";
    let title = namespace + "_" + name;
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  isLetters(event): boolean {
    const iKeycode = event.keyCode;
    return (iKeycode >= 65 && iKeycode <= 90) || (iKeycode >= 97 && iKeycode <= 122) || iKeycode === 39;
  }

  validateEmail() {
    if ((this.addMemberForm.get('Email').touched && !this.addMemberForm.get('Email').dirty) || !this.addMemberForm.get('Email').value) {
      this.validateInputFieldRequired();
    } else {
      this.validateInputFieldFormat();
    }
  }

  validateInputFieldRequired() {
    this.validationError = !this.addMemberForm.get('Email').value ? this.resourceService.getViewLabel('Global_Error_Required_Email') : undefined;
  }

  validateInputFieldFormat() {
    const optionValue = this.addMemberForm.get('Email').value;
    const resource = this.getResource('Email');
    const isValid = !!(String(optionValue).toLowerCase().match(resource.ValidationRegex));
    this.validationError = !isValid ? this.resourceService.getViewLabel('Global_Error_Valid_Email') : undefined;
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }

  closeModal() {
    this.dialogRef.close();
  }
}
